import { render } from "./Fair.vue?vue&type=template&id=9ca74a28&scoped=true"
import script from "./Fair.vue?vue&type=script&lang=js"
export * from "./Fair.vue?vue&type=script&lang=js"

import "./Fair.vue?vue&type=style&index=0&id=9ca74a28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ca74a28"]])

export default __exports__